/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  UpgradeableProxy,
  UpgradeableProxyInterface,
} from "../UpgradeableProxy";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

export class UpgradeableProxy__factory {
  static readonly abi = _abi;
  static createInterface(): UpgradeableProxyInterface {
    return new Interface(_abi) as UpgradeableProxyInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): UpgradeableProxy {
    return new Contract(address, _abi, runner) as unknown as UpgradeableProxy;
  }
}
